import { render, staticRenderFns } from "./Perfil.vue?vue&type=template&id=de8487b0&scoped=true&"
import script from "./Perfil.vue?vue&type=script&lang=ts&"
export * from "./Perfil.vue?vue&type=script&lang=ts&"
import style0 from "./Perfil.vue?vue&type=style&index=0&id=de8487b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de8487b0",
  null
  
)

export default component.exports